export default __webpack_public_path__ + "1d9ad1ed0bab462ab72c1b74c722b19a.png";